export default __webpack_public_path__ + "static/media/long-beep.7e97b86b.wav";